import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Loadable from 'components/Loadable';

// Guards
import GuestGuard from 'guards/GuestGuard';
import AuthGuard from 'guards/AuthGuard';
import AdminGuard from 'guards/AdminGuard';

// Layouts
import DashboardLayout from 'layout/Dashboard';

// Pages
const LoginPage = Loadable(lazy(() => import('pages/auth/LoginPage')));
const DashboardPage = Loadable(lazy(() => import('pages/dashboard/DashboardPage')));
const ProcessMappingPage = Loadable(lazy(() => import('pages/process-mapping/ProcessMappingPage')));
const AiTrainingPage = Loadable(lazy(() => import('pages/ai-training/AiTrainingPage')));

// Admin Pages
const MinioFilesPage = Loadable(lazy(() => import('pages/admin/MinioFilesPage')));
const FlowEnginePage = Loadable(lazy(() => import('pages/admin/FlowEnginePage')));
const PromptBuilderPage = Loadable(lazy(() => import('pages/admin/PromptBuilderPage')));
const SystemSettingsPage = Loadable(lazy(() => import('pages/admin/SystemSettingsPage')));
const PromptAuditPage = Loadable(lazy(() => import('pages/admin/PromptAuditPage')));

// Error
const Error404 = Loadable(lazy(() => import('pages/maintenance/404')));

// ==============================|| ROUTES ||============================== //

const router = createBrowserRouter([
  // ── Public (Login) ──
  {
    path: '/login',
    element: (
      <GuestGuard>
        <LoginPage />
      </GuestGuard>
    )
  },

  // ── Authenticated ──
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />
      },
      {
        path: 'dashboard',
        element: <DashboardPage />
      },
      {
        path: 'process-mapping',
        element: <ProcessMappingPage />
      },
      {
        path: 'process-mapping/:sessionId',
        element: <ProcessMappingPage />
      },
      {
        path: 'ai-training',
        element: <AiTrainingPage />
      },
      {
        path: 'admin/minio',
        element: <AdminGuard><MinioFilesPage /></AdminGuard>
      },
      {
        path: 'admin/flow-engine',
        element: <AdminGuard><FlowEnginePage /></AdminGuard>
      },
      {
        path: 'admin/prompt-builder',
        element: <AdminGuard><PromptBuilderPage /></AdminGuard>
      },
      {
        path: 'admin/settings',
        element: <AdminGuard><SystemSettingsPage /></AdminGuard>
      },
      {
        path: 'admin/prompt-audit',
        element: <AdminGuard><PromptAuditPage /></AdminGuard>
      }
    ]
  },

  // ── 404 ──
  {
    path: '*',
    element: <Error404 />
  }
]);

export default router;
